// Display formatters for money + dates.
//
// Currency formatting uses Intl.NumberFormat for grouping but operates on a
// `string` Decimal — Number coercion is acceptable for display only; the
// authoritative amount (signed and full-precision) lives in `MoneyDTO.amount`.

import type { MoneyDTO } from "./types";

export function formatMoney(m: MoneyDTO, locale: string = "en-SA"): string {
  const amount = Number(m.amount);
  if (Number.isNaN(amount)) return `${m.amount} ${m.currency}`;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: m.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  // Pure ISO YYYY-MM-DD: no timezone gymnastics needed.
  return iso;
}
